import { TableCompHead } from '../../../../../components/ui';
import { useQuery } from '../../../../../hooks/UseQuery';

interface IProps {
  processData: any;
}

const THead = ({ processData }: IProps) => {
  const processLength = processData.length;
  return (
    <thead
      style={{
        position: 'sticky',
        width: '100%',
        top: '-.5rem',
        border: '1px solid black',
        zIndex: '1',
        backgroundColor: '#38d9a9',
        color: '#fff',
      }}
    >
      <TableCompHead
        colSpan={5 + processLength}
        rowSpan={3}
        labels={['Doc No', 'Rev', 'Dated']}
        values={['M-PRD-54', '00', '7-10-2023']}
        heading="MAN PROCESS MATRIX"
      />
      <tr>
        <th rowSpan={2}>S.No.</th>
        <th rowSpan={2}>OPERATOR NAME</th>
        <th rowSpan={2}>Code</th>
        <th rowSpan={2}>Level</th>
        {processData.length > 0 && (
          <th colSpan={processData.length}>PROCESS NAME</th>
        )}
        <th rowSpan={2}>REMARKS</th>
      </tr>
      <tr>
        {processData.map((process: any) => (
          <th>{process.process_name}</th>
        ))}
      </tr>
    </thead>
  );
};

export default THead;
